module.exports = __webpack_public_path__ + "static/img/oval.7921a08b.png";